export enum DepartmentType {
  Root = 'root',
  Department = 'dept',
  Sector = 'sect',
  Division = 'div'
}
